exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".gap-40[data-v-2c2c1834] {\n  gap: 40px;\n}\n", ""]);

// exports
